"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const translationContext_1 = require("configs/translationContext");
const XIconCloseButton = ({ iconClassName, onClick }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("button", { onClick: onClick, "aria-label": t('general.close'), className: "_align-items-start _border-0 _line-height-sm _cursor-pointer \\\n        _bg-transparent _flex-shrink-0 _align-self-start", children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'xmark'], className: iconClassName }) }));
};
exports.default = XIconCloseButton;
